import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResumoRenegociacao } from '../shared/models/resumo-renegociacao.model';
import { PlanoRenegociacao } from '../shared/models/plano-renegociacao.model';
import BrowserUtils from '../shared/utils/browser-utils';
import { environment } from 'src/environments/environment';
import { ContratoService } from '../contrato/contrato.service';
import { NovoPlanoRenegociacao } from '../shared/models/novo-plano-renegociacao.model';
import { ApiService } from '../shared/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class RenegotiationResumeService {

  constructor(
    private http: HttpClient,
    private contratoService: ContratoService,
    private apiService: ApiService
  ) { }

  async fetchRenegotiationResume(contractId: string, planoId: string): Promise<ResumoRenegociacao> {
    const selectedPlan = this.contratoService.buscarNovoPlanoPeloId(planoId);
    const { id, ...planoSemId } = selectedPlan;

    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca',
      path: `/cobranca/contratos/${contractId}/renegociacoes/plano/resumo`,
      oldBrowserFallbackPath: `/contratos/${contractId}/renegociacoes/plano/resumo`
    })

    return this.http.post<ResumoRenegociacao>(path, planoSemId).toPromise();
  }

  getSelectedPlan(planId: string): NovoPlanoRenegociacao {
    return this.contratoService.buscarNovoPlanoPeloId(planId)
  }

  async confirmRenegotiation(contractId: string, selectedplan: NovoPlanoRenegociacao): Promise<any> {
    const { id, ...plan } = selectedplan;

    const path = this.apiService.getEndpoint({
      apiKey: 'vv-cred-contratos',
      path: `/contratos/portal/contratos/${contractId}/renegociacoes/plano/efetivar`,
      oldBrowserFallbackPath: `/portal/contratos/${contractId}/renegociacoes/plano/efetivar`
    })
    return this.http.post(path, plan).toPromise();
  }

  async downloadRenegociantionContract(renegotiationResume: ResumoRenegociacao) {
    const { dataAtual, ...contractRenegociation } = renegotiationResume;

    const path = this.apiService.getEndpoint({
      apiKey: 'vv-cred-contratos',
      path: '/contratos/relatorios/acordo-contrato-renegociacao',
      oldBrowserFallbackPath: '/relatorios/acordo-contrato-renegociacao'
    })

    const response = await this.http.post(path, contractRenegociation, { responseType: 'arraybuffer' }).toPromise();

    const blob = new Blob([response], { type: 'application/pdf' });
    const element = document.createElement('a');
    document.body.appendChild(element);
    element.setAttribute('target', '_blank');
    element.setAttribute('href', URL.createObjectURL(blob));
    element.click();
    element.remove();
  }

  get apiUrlService(): string {
    if (BrowserUtils.isOldFirefox()) {
      return `${environment.cdccorpApiURLService}/v1`;
    }

    return `${environment.apiURLService}/v1`;
  }
}
